'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import getIn from 'transmute/getIn';
import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
var initialState = '';
export default handleActions(_defineProperty({}, ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  if (state !== '') {
    return state;
  }

  return getIn(['bookInfo', 'customParams', 'locale'], action.payload);
}), initialState);